import React, {useState} from 'react';

import {Route, useHistory, useRouteMatch} from "react-router-dom";

import {new_client} from './Client.js';
import Clients from './Clients.js';


/*
Wraps Clients with routing
 */
let RoutingClients = ({
	clients,
	products,
	productData,
	createAnalysis,
	create,
	update,
	remove,
	showInfo,
	issueQuestionnaire,
	checkForQuestionnaire,
	deleteNewestQuestionnaire,
}) => {
	let { path, url } = useRouteMatch();
	const rootUrl = url;
	// remove ending / so we don't get //
	if (url.endsWith('/'))
		url = url.substring(0, url.length - 1);

	const history = useHistory();


	// action
	const [action, setAction] = useState();

	// on the client list: select, start creating
	const selectClient = id => {
		console.log(`selected a client`);
		history.push(`${url}/clients/${id}`);
		setAction();
	};

	const startCreating = () => {
		console.log(`started creating a client`);
		history.push(rootUrl);
		setAction('create');
	};


	// on a client: start editing, remove;

	const startEditing = () => {
		console.log(`started editing a client`);
		setAction('edit');
	};

	// from the client editor: send created client, send client update, cancel creating, cancel updating

	const handleCreateClient = async (...args) => {
		const newClientId = await create(...args);
		setAction();
		history.push(`${url}/clients/${newClientId}`);
	};

	const handleUpdateClient = (id, clientUpdate) => {
		update(id, clientUpdate);
		setAction();
	};

	const handleRemoveClient = id => {
		remove(id);
		setAction();
		history.push(rootUrl);
	};

	// cancel editing: return to client
	const cancelEditing = id => {
		console.log(`canceled editing a client`);
		setAction();
	};

	// cancel creating: return to overview
	const cancelCreating = () => {
		console.log(`canceled creating a client`);
		setAction();
		history.push(rootUrl);
	};

	const selectKairogramm = (clientId, id) => {
		console.log('selected a kairogramm');
		setAction();
		history.push(`${url}/clients/${clientId}/kairogramm/${id}`);
	};

	const selectAnalysis = (clientId, analysisType, id, part) => part ?
			`/api/clients/${clientId}/${analysisType}/${id}/${part}` :
			`/api/clients/${clientId}/${analysisType}/${id}`;



	// render

	return (
		<Route path = {`${url}/clients/:id`}
			children = {({ match }) => {
				let client;
				if (action === 'create')
					client = new_client;
				else
					if (clients && match)
						client = clients.find(t => t.id === match.params.id);

				return (
					<Clients
						action = {action}
						clients = {clients}
						client = {client}
						products = {products}
						productData = {productData}
						selectClient = {selectClient}
						createAnalysis = {createAnalysis}
						selectAnalysis = {selectAnalysis}
						selectKairogramm = {selectKairogramm}
						issueQuestionnaire = {issueQuestionnaire}
						checkForQuestionnaire = {checkForQuestionnaire}
						deleteNewestQuestionnaire = {deleteNewestQuestionnaire}
						startCreating = {startCreating}
						startEditing = {startEditing}
						cancelCreating = {cancelCreating}
						cancelEditing = {cancelEditing}
						create = {handleCreateClient}
						update = {handleUpdateClient}
						remove = {handleRemoveClient}
						showInfo = {showInfo}/>
				);
			}}/>
	);
};

export default RoutingClients;
